import React, { useContext } from "react";
import {
    Button,
    Container,
    Col,
    Row,
    Table,
    Alert
} from "react-bootstrap";

import Guest from "../../../layouts/Guest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faTicket, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { createEvent } from 'ics';
import {
    Card, CardBody, CardSubtitle
} from 'reactstrap';
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import { useGuestContext } from "../../../contexts/GuestContext";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import buddha_bathing from '../../../assets/img/baolinPrivate/buddhaBath.jpeg';
import lianghuang from '../../../assets/img/baolinPrivate/2025lianghuang.png';
// import lotus_divider from '../../../assets/img/baolinPrivate/buddhaBath.jpeg';




function EventTicket() {
    const { language } = useGuestContext();
    const history = useHistory();
    const redirectToRegister = () => {
        history.push('/register');
    };
    const location = useLocation();
    // Extracting guestId from location.state or URL search parameters
    const params = new URLSearchParams(window.location.search);
    let guestId = location.state?.guestId || params.get('guestid') || params.get('id');
    const formattedGuestId = String(guestId).padStart(4, '0');
    // const eventName = language === "English" ? "Bao Lin Chan Monastery 15th Anniversary" : "寶林禪寺15週年慶法會";
    const eventName = (
        <span>
            2025 Liang Huang Jeweled Repentance Weekly Sunday Service
        </span>
    );


    const date = "12/05/2024";
    const time = "9:30";
    const qrValue = `${process.env.REACT_APP_SERVER_URL}/event/checkin?id=${guestId}`;

    const addToCalendar = () => {
        // const event = {
        //     start: [2023, 4, 24, 9, 0],
        //     duration: { hours: 2 }, // Assuming 2 hours duration, adjust as needed
        //     title: eventName,
        //     description: document.getElementById('ticket-content').innerText,
        //     status: 'CONFIRMED',
        //     busyStatus: 'BUSY',
        // };
        const event = {
            start: [process.env.EVENT_DATE_YEAR, process.env.EVENT_DATE_MONTH, process.env.EVENT_DATE_DAY, process.env.EVENT_START_TIME_HOUR, process.env.EVENT_START_TIME_MIN],
            duration: { hours: 4 }, // Assuming 2 hours duration, adjust as needed
            title: "2025 Liang Huang Jeweled Repentance Weekly Sunday Service",
            description: "Description of the event", // Add a meaningful description
            status: 'CONFIRMED',
            busyStatus: 'BUSY',
        };

        createEvent(event, (error, value) => {

            if (error) {
                console.error('Error creating ICS', error);
                return;
            }
            const blob = new Blob([value], { type: 'text/calendar;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'baolin_buddha_bathing.ics'; // File name for the downloaded file
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };

    const Announcement = (
        <>
            <Alert className="alert-with-icon" variant="info">
                <span
                    data-notify="icon"
                    className="nc-icon nc-bell-55"
                ></span>
                <span data-notify="message font-weight-bold">
                    溫馨提醒：本週六(13/4)寶林十五週年慶，上午8:30開放報到，請於9:30前就座。因人數眾多停車不易，精舍從上午6:45~9:30安排往返Glen Iris Station的接駁車，請盡量搭乘。精舍前High St. 和Allison Ave.禁止停車。當日不開放置物櫃，個人物品請務必隨身保管。您的Guest ID和QR code已寄到email，期待您共同參與盛會！
                </span>
                <span data-notify="message">

                </span>
            </Alert>
            <Alert className="alert-with-icon mt-1" variant="success">
                <span
                    data-notify="icon"
                    className="nc-icon nc-bell-55"
                ></span>
                <span data-notify="message">
                    Friendly reminder: Bao Lin's 15th Anniversary is on 13/4 (Sat). Check-in begins at 8:30 AM. Please be seated by 9:30 AM. Due to limited parking, shuttle service to and from Glen Iris Station runs from 6:45 AM to 9:30 AM. No parking on High St in front of Bao Lin & Allison Ave. Lockers will not be available on that day, so please keep your personal belongings with you at all times. Guest ID & QR code will be sent via email. Looking forward to your presence.
                </span>
            </Alert>
        </>
    )

    const downloadImage = () => {
        const input = document.getElementById('ticket-for-download');
        html2canvas(input, {
            scale: 1,
            logging: true,
            useCORS: true,
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            const link = document.createElement('a');
            link.href = imgData;
            link.download = `baolin-15-ticket-id-${guestId}.jpg` // File name for the downloaded file
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }).catch(error => {
            console.error("Error generating JPEG", error);
        });
    };

    const cardBackgroundStyle = {
        // Default background that will be applied on larger screens
        backgroundImage: `linear-gradient(to left, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 1)), url(${require("../../../assets/img/baolinPrivate/2025lianghuang.png")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    };

    // Style for the lotus divider image
    const dividerStyle = {
        width: '60%', // Sets the width to match the parent container
        height: '80%', // Keeps the aspect ratio of the image
        maxWidth: '80%', // Ensures that the image doesn't exceed its original size
        // maxWidth: '100%', // Ensures that the image doesn't exceed its original size
        // display: 'block', // To prevent default inline behavior that includes white space
        // margin: 'auto' // To center the image in the available column space
        margin: '50px'
    };

    const ticketContent = (
        <>
            <div id="ticket-content">

                <div className="d-flex align-items-center mb-3">
                    <div className="w-100">
                        <h3 className="font-weight-bold font-size-lg text-info mb-3">
                            2025梁皇寶懺精進共修
                        </h3>
                        <span className=" font-weight-bold font-size-lg d-block">
                            {eventName}
                        </span>
                    </div>
                </div>
                {/* {Announcement} */}
                <hr style={{ borderColor: '#ddd', marginTop: 0, marginBottom: '1rem' }} />
                <Row>
                    <Col md={{ span: 4 }} className="d-flex flex-column justify-content-center align-items-center">

                        <Card className="bg-light text-center">
                            <CardBody>
                                <CardSubtitle className="mb-2 .text-black-50 font-weight-bold">Guest ID</CardSubtitle>
                                <span className="font-size-lg mb-0 text-center text-guest-id">
                                    {formattedGuestId}
                                </span>
                            </CardBody>
                        </Card>


                        <QRCodeCanvas value={qrValue} size={170} level={"H"} className="mt-3" />
                        <span className="font-size-md mb-0 text-center">
                            請提早30分鐘前入場報到
                        </span>
                        <span className="font-size-md mb-0">
                            Please arrive 30 mins in advance
                        </span>
                    </Col>
                    {/* 
                    <Col md={{ span: 3 }} className=" d-none d-md-block">
                        <img
                            src={require("../../../assets/img/baolinPrivate/budda_bath_cartoon_refined.png")}
                            // alt="divider"
                            style={dividerStyle}
                        />
                    </Col> */}
                    <Col md={{ span: 7 }} className="d-flex justify-content-center">
                        <Container className="mt-5">


                            <Row className="justify-content-center">
                                <h3 className="font-weight-bold font-size-sm text-dark mb-3">
                                    日程安排 ｜ Session Schedule
                                </h3>
                                <div className="table-responsive">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className="text-center">Scroll</th>
                                                <th className="text-center">
                                                    Session Date
                                                </th>
                                                <th className="text-center">
                                                    Session Time
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            <tr>
                                                <td class="text-center">
                                                    Scroll 1<br />
                                                    卷一
                                                </td>
                                                <td class="text-center">
                                                    May 11<br />
                                                    5月11日
                                                </td>
                                                <td class="text-center">
                                                    9:30 ~ 12:30
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    Scroll 2<br />
                                                    卷二
                                                </td>
                                                <td class="text-center">
                                                    May 18<br />
                                                    5月18日
                                                </td>
                                                <td class="text-center">
                                                    9:30 ~ 12:30
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    Scroll 3<br />
                                                    卷三
                                                </td>
                                                <td class="text-center">
                                                    June 1<br />
                                                    6月1日
                                                </td>
                                                <td class="text-center">
                                                    9:30 ~ 12:30
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    Scroll 4<br />
                                                    卷四
                                                </td>
                                                <td class="text-center">
                                                    June 8<br />
                                                    6月8日
                                                </td>
                                                <td class="text-center">
                                                    9:30 ~ 12:30
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    Scroll 5<br />
                                                    卷五
                                                </td>
                                                <td class="text-center">
                                                    June 15<br />
                                                    6月15日
                                                </td>
                                                <td class="text-center">
                                                    9:30 ~ 12:30
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    Scroll 6<br />
                                                    卷六
                                                </td>
                                                <td class="text-center">
                                                    July 6<br />
                                                    7月6日
                                                </td>
                                                <td class="text-center">
                                                    9:30 ~ 12:30
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    Scroll 7<br />
                                                    卷七
                                                </td>
                                                <td class="text-center">
                                                    July 13<br />
                                                    7月13日
                                                </td>
                                                <td class="text-center">
                                                    9:30 ~ 12:30
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    Scroll 8<br />
                                                    卷八
                                                </td>
                                                <td class="text-center">
                                                    July 20<br />
                                                    7月20日
                                                </td>
                                                <td class="text-center">
                                                    9:30 ~ 12:30
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    Scroll 9<br />
                                                    卷九
                                                </td>
                                                <td class="text-center">
                                                    August 3<br />
                                                    8月3日
                                                </td>
                                                <td class="text-center">
                                                    9:30 ~ 12:30
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    Scroll 10<br />
                                                    卷十
                                                </td>
                                                <td class="text-center">
                                                    August 10<br />
                                                    8月10日
                                                </td>
                                                <td class="text-center">
                                                    9:30 ~ 16:30
                                                </td>
                                            </tr>

                                        </tbody>
                                    </Table>
                                </div>
                            </Row>

                        </Container>
                    </Col>
                </Row>
            </div>
        </>)

    const ticket = (
        <>
            <Card className="card-box mb-5 p-4" id="ticket-for-download" style={{ ...cardBackgroundStyle }}>
                {ticketContent} {/* Render the ticket content */}
            </Card>
            <Row className="mt-1">
                {/* <Col>
                    <Button
                        className="btn-round btn-wd mr-1 "
                        style={{ fontWeight: 'bold' }}
                        href="#/"
                        type="button"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent the default anchor action
                            addToCalendar();
                        }}
                        variant="success"
                        size="md"
                        outline
                        block
                    >
                        <FontAwesomeIcon icon={faCalendar} />  {language === "English" ? "Download Calendar Event" : "下載日曆活動"}
                    </Button>
                </Col> */}
                <Col>
                    <Button
                        tag="a"
                        href="#/"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent the default anchor action
                            downloadImage();
                        }}
                        style={{ fontWeight: 'bold' }}
                        size="md"
                        className="btn-round btn-wd mr-1"
                        outline
                        variant="primary"
                        block
                    >
                        <FontAwesomeIcon icon={faTicket} />  {language === "English" ? "Download Ticket as JPEG" : "下載入場券"}
                    </Button>
                </Col>
                <Col>
                    <Button
                        tag="a"
                        href="#/"
                        onClick={redirectToRegister}
                        style={{ fontWeight: 'bold' }}
                        size="md"
                        className="btn-round btn-wd mr-1"
                        outline
                        variant="warning"
                        block
                    >
                        {language === "English" ? "Register more" : "繼續報名"} <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                </Col>
            </Row>
        </>
    );
    return (
        <>
            <Guest>
                <div className="content d-flex align-items-center p-0">
                    <Container>
                        {ticket}

                    </Container>
                </div>

            </Guest >
        </>
    );
}

export default EventTicket;
